import React from 'react';
import Plans from '../../components/Plans';
import PageLayout from '../../ui/layout/PageLayout';
import './styles.css';

function PlansPage() {
  return (
    <PageLayout title="Planos" subtitle="Assinatura e limites" primary={<Plans />} secondary={null} />
  );
}

export default PlansPage;
